<div class="flex flex-row w-screen h-screen">
  <div class="w-full md:w-1/2">
    <div
      class="sticky flex flex-row gap-1 items-center justify-between p-4 border border-light-120 backdrop-blur-md"
    >
      <p class="font-bold text-2xl text-light-300">Seedio</p>
    </div>

    <div class="flex flex-col items-center justify-center gap-5 pt-8">
      <div class="w-3/4 md:w-1/2 my-10">
        @switch (currentStep) {
        <!--  -->
        @case (1) {
        <app-generic-details-form />
        }
        <!--  -->
        @case (2) {
        <app-registration-message />
        }
        <!--  -->
        }
      </div>
    </div>
  </div>
  <div class="flex-1 hidden md:flex w-1/2">
    <img class="w-full" src="assets/images/seedio-registration.png" />
  </div>
</div>
